import { render, staticRenderFns } from "./Recomended.vue?vue&type=template&id=028f83dd&"
import script from "./Recomended.vue?vue&type=script&lang=js&"
export * from "./Recomended.vue?vue&type=script&lang=js&"
import style0 from "./Recomended.vue?vue&type=style&index=0&id=028f83dd&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports